import { render, staticRenderFns } from "./SettingsImportComponent.vue?vue&type=template&id=c9c2d1e8&scoped=true&"
import script from "./SettingsImportComponent.vue?vue&type=script&lang=js&"
export * from "./SettingsImportComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsImportComponent.vue?vue&type=style&index=0&id=c9c2d1e8&prod&lang=scss&scoped=true&"
import style1 from "./SettingsImportComponent.vue?vue&type=style&index=1&id=c9c2d1e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c2d1e8",
  null
  
)

export default component.exports